'use client';

import React, { useEffect, useState } from 'react';
import Script from 'next/script';

const STORAGE_KEY = 'gemp_cookie_consent';
const CONSENT_EVENT = 'gemp-cookie-consent-changed';

type AnalyticsScriptsProps = {
    gaMeasurementId?: string;
    gtmContainerId?: string;
};

export const AnalyticsScripts: React.FC<AnalyticsScriptsProps> = ({
    gaMeasurementId,
    gtmContainerId,
}) => {
    const [hasConsent, setHasConsent] = useState(false);

    useEffect(() => {
        const syncConsent = () => {
            setHasConsent(localStorage.getItem(STORAGE_KEY) === 'accepted');
        };

        syncConsent();
        window.addEventListener('storage', syncConsent);
        window.addEventListener(CONSENT_EVENT, syncConsent);

        return () => {
            window.removeEventListener('storage', syncConsent);
            window.removeEventListener(CONSENT_EVENT, syncConsent);
        };
    }, []);

    if (!hasConsent) {
        return null;
    }

    return (
        <>
            {gaMeasurementId ? (
                <>
                    <Script
                        id="ga-script"
                        src={`https://www.googletagmanager.com/gtag/js?id=${gaMeasurementId}`}
                        strategy="afterInteractive"
                    />
                    <Script id="ga-inline" strategy="afterInteractive">
                        {`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${gaMeasurementId}');
`}
                    </Script>
                </>
            ) : null}
            {gtmContainerId ? (
                <>
                    <Script id="gtm-inline" strategy="afterInteractive">
                        {`
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
`}
                    </Script>
                    <noscript>
                        <iframe
                            src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}`}
                            height="0"
                            width="0"
                            style={{ display: 'none', visibility: 'hidden' }}
                        />
                    </noscript>
                </>
            ) : null}
        </>
    );
};
